var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84467 21.1017L8.84466 21.1017L0.719654 12.9767C0.426796 12.6838 0.426766 12.2089 0.719659 11.916C0.719664 11.916 0.719668 11.916 0.719672 11.916L2.48738 10.1482L2.4874 10.1482C2.78027 9.85533 3.25516 9.85533 3.54803 10.1482L3.54805 10.1482L9.02144 15.6216L9.37499 15.9751L9.72854 15.6216L21.4519 3.89824L21.0987 3.54498L21.4519 3.89824C21.7448 3.60537 22.2197 3.60537 22.5126 3.89824L24.2803 5.66601L24.6339 5.31246L24.2803 5.66602C24.5732 5.95888 24.5732 6.43377 24.2803 6.7267L9.90534 21.1017C9.61241 21.3946 9.13754 21.3946 8.84467 21.1017Z",
    fill: "#ED6C76",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconRed);
export default __webpack_public_path__ + "static/media/check-icon-red.a755e120505a569cec22afce715da97f.svg";
export { ForwardRef as ReactComponent };